/**
 * 트레일 상수 정의
 * 
 * ⚠️ CRITICAL: 새로운 트레일 추가 시 필수 작업
 * 1. 이 파일의 TRAIL_NAMES에 트레일 추가
 * 2. 동기화 확인: npm run validate-trails
 * 
 * 성능 최적화: DB 쿼리 제거로 응답 시간 단축
 */

// 현재 총 4개 트레일 - 새 트레일 추가 시 이 주석 업데이트 필요
export const TRAIL_NAMES: { [key: string]: string } = {
  "T_ROUTE_MNG0000000001": "남파랑길",
  "T_ROUTE_MNG0000000043": "서해랑길", 
  "T_ROUTE_MNG0000000047": "DMZ 평화의 길",
  "T_THEME_MNG0000011235": "해파랑길"
} as const;

/**
 * 트레일 ID로 트레일 이름 조회
 * @param trailId 트레일 ID
 * @returns 트레일 이름 (없으면 "알 수 없음")
 */
export function getTrailName(trailId: string): string {
  const trailName = TRAIL_NAMES[trailId];
  
  // 개발 환경에서 누락된 트레일 경고
  if (!trailName && process.env.NODE_ENV === 'development') {
    console.error(`🚨 TRAIL SYNC ERROR: Trail ID "${trailId}" not found in constants!`);
    console.error(`📝 Add this trail to src/constants/trails.ts:`);
    console.error(`   "${trailId}": "[TRAIL_NAME]"`);
    console.error(`🔧 Then run: npm run validate-trails`);
  }
  
  return trailName || "알 수 없음";
}

/**
 * 모든 트레일 목록 조회
 * @returns 트레일 ID와 이름 배열
 */
export function getAllTrails(): Array<{ id: string; name: string }> {
  return Object.entries(TRAIL_NAMES).map(([id, name]) => ({ id, name }));
}

/**
 * 트레일 존재 여부 확인
 * @param trailId 트레일 ID
 * @returns 존재하면 true
 */
export function isValidTrailId(trailId: string): boolean {
  return trailId in TRAIL_NAMES;
}